import { styled } from '@mui/material';
import { useCallback, useMemo } from 'react';
import type { GroupBase, ValueContainerProps } from 'react-select';
import { components } from 'react-select';

import type { IMarketplace } from '../helpers/types';

export const MarketplaceValueContainer = (
  props: ValueContainerProps<IMarketplace, true, GroupBase<IMarketplace>>,
) => {
  const { selectProps, getValue } = props;
  const values = getValue();

  const handleClick = useCallback(() => {
    if (selectProps.menuIsOpen) {
      selectProps.onMenuClose();
    } else {
      selectProps.onMenuOpen();
    }
  }, [selectProps]);

  const text = useMemo(() => {
    let text;
    if (values.length === 0) {
      text = 'All Marketplaces';
    } else if (values.length === 1) {
      text = values[0]?.label ?? '';
    } else {
      text = `${values.length} marketplaces`;
    }
    return text;
  }, [values]);

  return (
    <components.ValueContainer {...props}>
      <ValueContainerWrapper onClick={handleClick}>{text}</ValueContainerWrapper>
    </components.ValueContainer>
  );
};

const ValueContainerWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  width: '100%',
  fontFamily: theme.fonts.telka,
  fontSize: '16px',
  fontWeight: 400,
  color: '#2C3134',
}));
